export default {
  items: [
    {
      label: 'Team Members',
      href: '/users',
      icon: 'fa-solid fa-users',
      activeUrl: '/users',
      show: (store) => store.canManageUsers
    },
    {
      label: 'White Label Settings',
      href: '/white_label_configurations',
      icon: 'fa-solid fa-tag',
      activeUrl: '/white_label_configurations',
      show: (store) => store.canManageWlc
    },
    {
      label: 'Integrations',
      href: '/integrations',
      icon: 'fa-solid fa-plug',
      activeUrl: '/integrations',
      show: (store) => store.canViewIntegrations
    },
    {
      label: 'AI Settings',
      href: '/ai_settings',
      icon: 'fa-solid fa-robot',
      activeUrl: '/ai_settings',
      show: (store) => store.canViewIntegrations
    },
    {
      label: 'API Keys',
      href: '/api_tokens',
      icon: 'fa-solid fa-key',
      activeUrl: '/api_tokens',
      show: (store) => store.canManageApiKeys
    },
    {
      label: 'MCP Tokens',
      href: '/mcp_tokens',
      icon: 'fa-solid fa-plug',
      activeUrl: '/mcp_tokens',
      show: (store) => store.canManageMcpTokens
    },
    {
      label: 'Webhooks',
      href: '/webhooks',
      icon: 'fa-solid fa-satellite-dish',
      activeUrl: '/webhooks',
      show: (store) => store.canManageApiKeys
    }
  ]
}
